import { HiCheckCircle, HiX } from "react-icons/hi";

export default function Toast({ message, onClose }) {
  return (
    <div className="fixed top-6 right-6 z-[9999] animate-slide-in">
      <div className="flex items-start gap-3 bg-white border border-green-200 shadow-xl rounded-2xl p-4 w-[340px]">
        <HiCheckCircle className="text-green-500 text-2xl mt-0.5" />

        <div className="flex-1">
          <p className="font-semibold text-gray-900">Erfolgreich</p>
          <p className="text-sm text-gray-600">{message}</p>
        </div>

        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600"
        >
          <HiX />
        </button>
      </div>
    </div>
  );
}
